import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Sparkles, Users } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-20 bg-primary relative overflow-hidden">
      {/* Decorative patterns */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-40 h-40 rounded-full border-2 border-primary-foreground" />
        <div className="absolute bottom-10 right-10 w-60 h-60 rounded-full border-2 border-primary-foreground" />
        <div className="absolute top-1/2 left-1/3 w-20 h-20 rounded-full border border-primary-foreground" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* For Couples */}
          <div className="text-center lg:text-left">
            <Sparkles className="w-12 h-12 text-primary-foreground mb-4 mx-auto lg:mx-0" />
            <h2 className="font-serif text-3xl md:text-4xl font-semibold text-primary-foreground mb-4">
              ¿Preparando tu boda?
            </h2>
            <p className="text-primary-foreground/80 mb-6 max-w-md mx-auto lg:mx-0">
              Encuentra los mejores proveedores, guarda tus favoritos y organiza tu boda perfecta sin intermediarios.
            </p>
            <Link to="/vendors">
              <Button variant="heroOutline" size="lg">
                Empezar a explorar
              </Button>
            </Link>
          </div>

          {/* Divider */}
          <div className="hidden lg:block absolute left-1/2 top-1/2 -translate-y-1/2 w-px h-32 bg-primary-foreground/20" />

          {/* For Vendors */}
          <div className="text-center lg:text-left">
            <Users className="w-12 h-12 text-primary-foreground mb-4 mx-auto lg:mx-0" />
            <h2 className="font-serif text-3xl md:text-4xl font-semibold text-primary-foreground mb-4">
              ¿Eres proveedor?
            </h2>
            <p className="text-primary-foreground/80 mb-6 max-w-md mx-auto lg:mx-0">
              Únete a nuestra plataforma y conecta con miles de parejas que buscan servicios como los tuyos.
            </p>
            <Link to="/backoffice">
              <Button variant="heroOutline" size="lg">
                Registrar mi negocio
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
